import {UIBrick, registerBrick} from 'olympe';
import ReactDOM from 'react-dom';
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import {getIcon} from '../shared/utils/_icons.jsx';
import {combineProps, createEvents} from '../shared/_helpers';

/**
 *
 */
export default class TopButton extends UIBrick {
    /**
     * This method runs when the brick is ready in the HTML DOM.
     * @override
     * @param {!BrickContext} context
     * @param {!Element} elementDom
     */
    draw(context, elementDom) {
        const events = createEvents([
            {
                name: 'onItemSelected',
                event: context.getEvent('On item selected'),
                before: (value) => {
                    context.getProperty('Selected item').set(value);
                },
            },
            {
                name: 'clearSelection',
                event: context.getEvent('Clear selection'),
                before: () => {
                    context.getProperty('Selected item').set('');
                },
            },
        ]);

        combineProps([
            {name: 'title', prop: context.getProperty('Title'), defaultValue: ''},
            {name: 'listTitle', prop: context.getProperty('List title'), defaultValue: ''},
            {name: 'possibleValues', prop: context.getProperty('Possible values'), defaultValue: ','},
            {name: 'mainColor', prop: context.getProperty('Main color')},
            {name: 'backgroundColor', prop: context.getProperty('Background color')},
            {name: 'selectedMainColor', prop: context.getProperty('Selected main color')},
            {name: 'selectedBackgroundColor', prop: context.getProperty('Selected background color')},
            {name: 'muiIcon', prop: context.getProperty('MUI Icon'), defaultValue: ''},
            {name: 'selectedItem', prop: context.getProperty('Selected item'), defaultValue: ''},
        ]).subscribe((props) => {
            ReactDOM.render(
                (<TopButton.Component
                    {...props}
                    {...events}
                    context={context}
                />), elementDom);
        });
    }
}

registerBrick('017af7822772ab946ea2', TopButton);


/**
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.listTitle
 * @param {string} props.possibleValues
 * @param {Color} props.mainColor
 * @param {Color} props.backgroundColor
 * @param {Color} props.selectedMainColor
 * @param {Color} props.selectedBackgroundColor
 * @param {string} props.muiIcon
 * @param {string} props.selectedItem
 * @param {function(*)} props.onItemSelected
 * @param {function(*)} props.clearSelection
 * @return {JSX.Element}
 * @constructor
 */
TopButton.Component = (props) => {
    const topButtonStyle = {
        background: props.backgroundColor.toHexString(),
        borderColor: props.mainColor.toHexString(),
        color: props.mainColor.toHexString(),
    };

    const topButtonSelectedStyle = {
        background: props.selectedBackgroundColor.toHexString(),
        borderColor: props.selectedMainColor.toHexString(),
        color: props.selectedMainColor.toHexString(),
    };

    const items = props.possibleValues.split(',');
    const itemSelected = props.selectedItem !== '';

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div onClick={() => {
            if (itemSelected) {
                props.clearSelection();
            }
        }}
        className={itemSelected ? 'top-button-selected' : 'top-button'}
        style={itemSelected ? topButtonSelectedStyle : topButtonStyle}
        >
            <div className={'top-button-grid'}>
                <div className={'top-button-grid-icon'}>
                    {getIcon(props.muiIcon, true, {style: {fontFamily:'inherit', fontSize: '1.2rem'}})}
                </div>
                <div className={'top-button-grid-title'}>{props.title}</div>
                <div/>
                <div className={'top-button-grid-dropdown'} onClick={handleClick}>
                    <div className={'top-button-grid-list-title'}>
                        {itemSelected ? props.selectedItem : props.listTitle}
                    </div>
                    {getIcon('KeyboardArrowDown', true, {style: {fontSize: '14px'}})}
                </div>
                <div className={'dropdown'}>
                    <Menu
                        id="simple-menu"
                        color="primary"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {items.map((item) => {
                            return (
                                <MenuItem onClick={() => {
                                    props.onItemSelected(item);
                                    handleClose();
                                }}
                                key={'MenuItem' + props.title + item}
                                onMouseEnter={(e) => e.target.style.backgroundColor = props.mainColor.toHexString() + '44'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#00000000'}
                                >{item}</MenuItem>
                            );
                        } )}
                    </Menu>
                </div>
            </div>
        </div>
    );
};
